import { render, staticRenderFns } from "./ActividadesView.vue?vue&type=template&id=121b74ce&scoped=true&"
import script from "./ActividadesView.vue?vue&type=script&lang=ts&"
export * from "./ActividadesView.vue?vue&type=script&lang=ts&"
import style0 from "./ActividadesView.vue?vue&type=style&index=0&id=121b74ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b74ce",
  null
  
)

export default component.exports